import React, { useState } from "react";
import Api from "../../services/ApiService";
import { Button, Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthDispatch } from "../../context/AuthContext";


/**
 * LoginComponent
 * 
 * Component with gui and handlers for hw and customer login
 * 
 * used in index, qrPage
 * 
 * @param {*} props 
 * @returns html
 */
const LoginComponent = (props) => {

    const API = new Api(); // API object
    const { next } = useParams() || null;

    const [email, setEmail] = useState(""); // email field
    const [password, setPassword] = useState(""); // password field
    const [errorMsgHidden, setErrorMsgHidden] = useState(true); // show/hide error message
    const [errorMsg, setErrorMsg] = useState(""); // error message text
    const [isLoading, setIsLoading] = useState(false); // is login loading
    const [formClass, setFormClass] = useState("");

    const dispatch = useAuthDispatch(); // use auth context to dispatch commands
    const navigate = useNavigate(); // navigation


    // when login button was pressed
    const submitHandler = (e) => {
        e.preventDefault();
        setFormClass("");
        setIsLoading(true);
        setErrorMsgHidden(true);
        API.login(email, password)
        .then((res) => {
            setIsLoading(false);
            let db_user = res.data.partner;
            dispatch('LOGIN', db_user);
            delete res.data['partner'];
            localStorage.setItem('token', JSON.stringify(res.data));
            if (db_user.x_is_house_management) {
                let qr = localStorage.getItem('qr') || null;
                if (qr === null || qr === undefined) {
                    if (next !== undefined) {
                        let next_normalised = next.replaceAll('_', '/');
                        navigate(`${next_normalised}`);
                    } else {
                        navigate('/hw/dashboard/')
                    }
                } else {
                    navigate('/hw/dashboard/anlagen/top');
                }
            }
            else navigate('/dashboard');
        })
        .catch((e) => {
            setIsLoading(false);
            setErrorMsg(e.response.data.detail);
            setErrorMsgHidden(false);
            setFormClass("horizontal-shake");
        })
    }


    // GUI
    return (
        <Form onSubmit={e => submitHandler(e)} className={formClass}>
            <Row>
                <Form.Group className="mb-3" controlId="username">
                    <FloatingLabel label="E-Mail">
                        <Form.Control
                            name="email"
                            autoComplete="email"
                            type="email"
                            placeholder="E-Mail"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                        />
                    </FloatingLabel>
                </Form.Group>
                <Form.Group className="mb-3" controlId="password">
                    <FloatingLabel label="Passwort">
                        <Form.Control
                            name="password"
                            autoComplete="password"
                            type="password"
                            placeholder="Passwort"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                    </FloatingLabel>
                    <Form.Text hidden={errorMsgHidden} className="text-danger">
                        <b>{errorMsg}</b>
                    </Form.Text>
                </Form.Group>
                <Col className="mb-4 text-end">
                    <a href="password/vergessen" onClick={e => {e.preventDefault(); props.view('pass-forgot')}} className="link-energo-orange">Passwort anfordern / vergessen?</a>
                </Col>
                <Col xs="12">
                    {isLoading? 
                        <Spinner animation="border" variant="warning"/>
                    :
                        <Button variant="warning" type="submit">Anmelden</Button>
                    }     
                </Col>
            </Row>
        </Form>
    )
}

export default LoginComponent;